import React from 'react'
import PropTypes from 'prop-types'
import { best } from '@opendevtools/wcag-color'

import { intToBool } from '../../utils/formatting'
/* Relative imports to comply with Headless Webpack config */
import PollOptionsComponent from '../PollOptionsComponent/PollOptionsComponent'
import PollVoteComponent from '../PollVoteComponent/PollVoteComponent'

import './PollItemComponent.scss'

const getQuestion = (poll, questionStyles) => {
  const { backgroundColor } = questionStyles
  const color = backgroundColor
    ? best('#000000', '#ffffff', backgroundColor)
    : null

  return (
    <div className="question-wrapper" style={{ backgroundColor, color }}>
      {poll.question}
    </div>
  )
}

const PollItemComponent = (props) => {
  const {
    poll,
    progressBarStyles,
    isVotingAllowed,
    radioButtonStyles,
    answerPoll,
    questionStyles,
  } = props

  const canVote = isVotingAllowed && intToBool(poll.open_p)

  return (
    <div className="poll-item-component">
      {canVote ? (
        <PollVoteComponent
          poll={poll}
          radioButtonStyles={radioButtonStyles}
          question={getQuestion(poll, questionStyles)}
          answerPoll={answerPoll}
        />
      ) : (
        <>
          {getQuestion(poll, questionStyles)}
          <PollOptionsComponent
            poll={poll}
            progressBarStyles={progressBarStyles}
          />
        </>
      )}
    </div>
  )
}

PollItemComponent.propTypes = {
  poll: PropTypes.object,
  progressBarStyles: PropTypes.shape({
    strokeColor: PropTypes.string,
    strokeWidth: PropTypes.number,
    trailColor: PropTypes.string,
  }),
  radioButtonStyles: PropTypes.shape({
    passiveColor: PropTypes.string,
    activeColor: PropTypes.string,
  }),
  questionStyles: PropTypes.shape({
    backgroundColor: PropTypes.string,
  }),
  isVotingAllowed: PropTypes.bool,
  answerPoll: PropTypes.func,
}

PollItemComponent.defaultProps = {
  questionStyles: {},
}

export default PollItemComponent
